const validate = values => {
  const errors = {}

  if (values?.web_link_form?.webLinkScreenType === "1") {
    if (
      values?.web_link_form?.linkType === "1" &&
      !values?.web_link_form?.webUrl
    ) {
      errors.web_link_form = {
        ...errors.web_link_form,
        webUrl: "The link address is required",
      }
    }

    if (
      values?.web_link_form?.linkType === "1" &&
      !!values?.web_link_form?.webUrl &&
      !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
        values?.web_link_form?.webUrl
      )
    ) {
      errors.web_link_form = {
        ...errors.web_link_form,
        webUrl:
          "The URL is invalid! It must include both http:// or https:// and suffix like .com",
      }
    }

    if (
      values?.web_link_form?.linkType === "3" &&
      (!values?.web_link_form?.phoneNumber ||
        values?.web_link_form?.phoneNumber?.length === 0)
    ) {
      errors.web_link_form = {
        ...errors.web_link_form,
        phoneNumber: "The phone number is required",
      }
    }

    if (
      values?.web_link_form?.linkType === "2" &&
      !values?.web_link_form?.IOSdeeplink
    ) {
      errors.web_link_form = {
        ...errors.web_link_form,
        IOSdeeplink:
          "The IOS deeplink is required if you select to be open as an app",
      }
    }

    if (
      values?.web_link_form?.linkType === "2" &&
      !values?.web_link_form?.androidDeeplink
    ) {
      errors.web_link_form = {
        ...errors.web_link_form,
        androidDeeplink:
          "The Android deeplink is required if you select to be open as an app",
      }
    }

    if (
      values?.web_link_form?.linkType === "2" &&
      !values?.web_link_form?.appStoreLink
    ) {
      errors.web_link_form = {
        ...errors.web_link_form,
        appStoreLink:
          "The Apple Store link is required if you select to be open as an app",
      }
    }

    if (
      values?.web_link_form?.linkType === "2" &&
      !values?.web_link_form?.googleStoreLink
    ) {
      errors.web_link_form = {
        ...errors.web_link_form,
        googleStoreLink:
          "The Google Play Store link is required if you select to be open as an app",
      }
    }
  }

  if (values?.web_link_form?.webLinkScreenType === "2") {
    values?.web_link_form?.multiWebLink.forEach((link, index) => {
      if (!link.name) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              name: "The link name is required!",
            },
          },
        }
      }

      if (link?.linkType === "1" && !link?.webUrl) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              webUrl: "The link address is required!",
            },
          },
        }
      }

      if (
        link?.linkType === "1" &&
        !!link?.webUrl &&
        !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
          link?.webUrl
        )
      ) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              webUrl:
                "The URL is invalid! It must include both http:// or https:// and suffix like .com",
            },
          },
        }
      }

      if (
        link?.linkType === "3" &&
        (!link?.phoneNumber || link?.length === 0)
      ) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              phoneNumber: "The phone number is required!",
            },
          },
        }
      }

      if (link?.linkType === "2" && !link?.IOSdeeplink) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              IOSdeeplink:
                "The IOS deeplink is required if you select to be open as an app",
            },
          },
        }
      }

      if (link?.linkType === "2" && !link?.androidDeeplink) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              androidDeeplink:
                "The Android deeplink is required if you select to be open as an app",
            },
          },
        }
      }

      if (link?.linkType === "2" && !link?.appStoreLink) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              appStoreLink:
                "The Apple Store link is required if you select to be open as an app",
            },
          },
        }
      }

      if (link?.linkType === "2" && !link?.googleStoreLink) {
        errors.web_link_form = {
          ...errors.web_link_form,
          multiWebLink: {
            ...errors.web_link_form?.multiWebLink,
            [`${index}`]: {
              googleStoreLink:
                "The Google Play Store link is required if you select to be open as an app",
            },
          },
        }
      }
    })
  }

  if (!values?.web_link_form?.name) {
    errors.web_link_form = {
      ...errors.web_link_form,
      name: "The name is required!",
    }
  }

  return errors
}

export default validate
